module.exports = __webpack_public_path__ + "static/media/SBS636.ad310483.png";